import { createContext, useCallback, useContext, useEffect, useState } from "react";

export type RailSuggestion = { id: string; text: string };

interface SideRailState {
  open: boolean;
  contextLabel: string;
  suggestions: RailSuggestion[];
  openRail: (label: string, suggestions?: RailSuggestion[]) => void;
  closeRail: () => void;
  toggle: (label?: string, suggestions?: RailSuggestion[]) => void;
}

const Ctx = createContext<SideRailState | null>(null);

export function SideRailProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const [contextLabel, setLabel] = useState("");
  const [suggestions, setSuggestions] = useState<RailSuggestion[]>([]);

  const openRail = useCallback((label: string, sugs: RailSuggestion[] = []) => {
    setLabel(label);
    setSuggestions(sugs);
    setOpen(true);
  }, []);
  const closeRail = useCallback(() => setOpen(false), []);
  const toggle = useCallback(
    (label?: string, sugs: RailSuggestion[] = []) => {
      setOpen((v) => {
        if (!v) {
          if (label !== undefined) setLabel(label);
          if (sugs.length) setSuggestions(sugs);
        }
        return !v;
      });
    },
    []
  );

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <Ctx.Provider value={{ open, contextLabel, suggestions, openRail, closeRail, toggle }}>
      {children}
    </Ctx.Provider>
  );
}

export function useSideRail() {
  const v = useContext(Ctx);
  if (!v) throw new Error("SideRailProvider missing");
  return v;
}
